import src from "IMAGE";
export default { src, width: 2019, height: 1159, blurWidth: 8, blurHeight: 5, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAASUlEQVR42jWMSQ7AMAgDObdNG7Zbxf+fmRFR5oCMDZbn8DcIM0OIu6vqzkaDU1WSmQT3gYCpasLjnJP9a14YA0euhh4aIoKL7SzkQQdKZZGjugAAAABJRU5ErkJggg=="};
